/* eslint-disable no-undef */
import {createRouter, createWebHashHistory} from 'vue-router';
import store from './store';
const LS_ROUTE_KEY = "LS_ROUTE_KEY";
const routes = [
    {
        path: '/welcome',
        alias: ['/'],
        name: 'welcome',
        component: () => import('./pages/Welcome.vue'),
        beforeEnter() {
            store.commit("form/removeAll");
        }
    },
    {
        path: '/term-and-condition',
        name: 'termAndCondition',
        component: () => import('./pages/TermAndConditions.vue'),
        beforeEnter(to, from, next) {
            const lastRouteName = localStorage.getItem(LS_ROUTE_KEY);
            if(lastRouteName!=="welcome" && lastRouteName!=="termAndCondition"){
                next('/welcome');
            }else{
                next(next);
            }
        }
    },
    {
        path: '/form',
        name: 'form',
        component: () => import('./pages/Form.vue'),
        beforeEnter(to, from, next) {
            const lastRouteName = localStorage.getItem(LS_ROUTE_KEY);
            if(store.getters['form/result']===null || (lastRouteName!=="termAndCondition" && lastRouteName!=="form" && lastRouteName!=="continue")){
                next('/term-and-condition');
            }else{
                next(next);
            }
        }
    },
    {
        path: '/thank-you',
        name: 'thankYou',
        component: () => import('./pages/Thankyou.vue'),
        beforeEnter(to, from, next) {
            const lastRouteName = localStorage.getItem(LS_ROUTE_KEY);
            if((lastRouteName!=="form" && lastRouteName!=="thankYou" && lastRouteName!=="continue")){
                next('/welcome');
            }else{
                next(next);
            }
        }
    },
    {
        path: '/unsubscribe',
        name: 'unsubscribe',
        component: () => import('./pages/Unsubscribe.vue'),
        beforeEnter(to, from, next) {
            if (to.query == {} || to.query.id==null){
                next('/welcome');
            } else {
                store.dispatch("form/unsubscribe", to.query.id);
                next();
            }
        }
    },
    {
        path: '/continue',
        name: 'continue',
        async beforeEnter(to, from, next) {
            if (to.query == {} || to.query.id==null){
                next('/welcome');
            } else {
                await store.dispatch("form/getUser", { id:to.query.id, locale: store.getters["preferences/locale"]});
                localStorage.setItem(LS_ROUTE_KEY, to.name);
                next('form');
            }
        }
    },
];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
    scrollBehavior () {
        return { left: 0, top: 0 };
    },
});
router.afterEach(to => {
  localStorage.setItem(LS_ROUTE_KEY, to.name);
});
export default router;